// extracted by mini-css-extract-plugin
export default {"trigger":"teaser_trigger__sY0Ij","triggerText":"teaser_triggerText__sNuTS","mainWrap":"teaser_mainWrap__WB7RS"};